(function () {
    angular.module('ui2.0Service').factory('communicationService', ['$http', '$rootScope', '$compile', '$window', '$timeout', 'formService','dataManipulationService',function ($http, $rootScope, $compile, $window, $timeout, formService,dataManipulationService){

        return{
            uploadFile : uploadFile
        }

        function uploadFileApiCall(elem,formData,apiURL, header) {
            return new Promise((resolve,reject) => {
                let headers = {
                    ...header,
                    "Content-Type": undefined
                }
                var promise = $http.post( appName + apiURL, formData, {
                    transformRequest: angular.identity,
                    headers: headers,
                }).then(function (response) {
                    if(response.status === 201 && response.data.status === "CREATED"){
                        let modalToClose;
                        angular.element(elem).val('');
                        let _res = responseHandler(response);
                        resolve(_res);
                    }else{
                        Toaster.create(response.data.message,{iconClass:"icon-Information_filled"});
                    }
                }, function(d) {
                    Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                }).catch(function (error){
                    let id = SirionUtils.drsErrorCodes[error.response.data.errorCode];
                    window.Toaster.create(ExtR.getLabel(id || 6552), "icon-Information");
                })
            })
        }

        function calculateFilesSize (inputFilesElem, filesList) {
            let fileSize = 0,
                filesArr = (inputFilesElem.files && inputFilesElem.files.length) ? inputFilesElem.files : filesList;
            try {
                let file;
                for (let i = 0; i < filesArr.length; i++) {
                    file = filesArr[i];
                    fileSize += file.size;
                }
            } catch (err) {
                // If unable to calculate fileSize then just proceed
            }
            return fileSize;
        };

        /*
        * This function must be called using the `call` syntex
        * e.g : uploadFile.call($scope,elem,returnFileElem,droppedFilesList)
        * */
        function uploadFile(elem,callback,returnFileElem,droppedFilesList) {
            return new Promise((resolve,reject) => {
                let drsObject = JSON.parse(sessionStorage.getItem('drsObject'))
                if (!droppedFilesList && elem.files && elem.files.length == 0) {
                    return;
                }
                var INVOICE_VALIDEXTENSIONS = ["doc", "docx", "pdf"];
                var isDuplicate = false,
                    extraFields = [],
                    indexFU = 0,
                    modalToClose,
                    fileSize,
                    that = this,        // this refers to the $scope variable
                    apiURL = $(elem).attr("action");

                if(that.drsEnabled && drsObject) {
                    apiURL = drsObject.drsUrl;
                    apiURL = apiURL ? apiURL+'/v1/upload' : '/file/v1/upload';
                }
                if (angular.element(elem).attr("extraFields")) {
                    extraFields = JSON.parse($(elem).attr("extraFields"));
                }
                that.files = droppedFilesList != undefined ? droppedFilesList : elem.files;

                if ($rootScope.alertBoxes.length > 0) {
                    modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                    modalToClose.close();
                }
                if ($(elem).hasClass("singleFile") && $(elem).closest("fieldset").find(".file").size() > 0) {
                    var msg = intl_msg[23560];
                    Toaster.create(msg,{iconClass:"icon-Information_filled"});
                    return;
                }
                if ($(elem).hasClass("singleFile") &&
                    $(elem).closest("div").attr("allowedExtensions") != undefined &&
                    that.files[0] && that.files[0].name
                ) {
                    let allowedExtenisons = $(elem).closest("div").attr("allowedExtensions"),
                        fileNameSplitArr = that.files[0].name.split('.'),
                        currextsn = fileNameSplitArr[fileNameSplitArr.length - 1].toLowerCase();

                    if (allowedExtenisons.indexOf(currextsn) == -1) {
                        let msg = intl_msg[6431] + " Allowed extensions are : " + allowedExtenisons;
                        Toaster.create(msg,{iconClass:"icon-Information_filled"});
                        return;
                    }
                }
                if (($(elem).closest(".formPost").hasClass("singleFile") || ($(elem).hasClass("singleFile"))) && (fileSize = calculateFilesSize(elem)) > 10485760) {
                    var msg = intl_msg[6439].replace(/"/g, "")  +  parseInt(MAX_MASSEMAIL_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                        +    parseInt(fileSize / 1048576) + " MB";

                    Toaster.create(msg,{iconClass:"icon-Information_filled"});
                    return;
                } else if (!$(elem).hasClass("singleFile") && (fileSize = calculateFilesSize(elem)) >= 104857600) {

                    var msg = intl_msg[6439].replace(/"/g, "") + parseInt(MAX_UPLOAD_SIZE / 1000000) + " MB. "+intl_msg[27628]+" "
                        + parseInt(fileSize / 1048576) + " MB";
                    Toaster.create(msg,{iconClass:"icon-Information_filled"});
                    return;
                }
                /**  new code to show popup in case of duplicate file as per the new dom structure  **/
                if (angular.element(elem).closest('form').find('.jx-fileListDiv').length) {
                    var fileNamesElm = angular.element(elem).closest('form').find('.jx-fileListDiv').find('.jx-uplodedFN');
                    if (_.indexOf(Array.prototype.map.call(fileNamesElm, function (x) {
                        return x.innerText.trim();
                    }), that.files[indexFU].name) > -1) {
                        Toaster.create(intl_msg[6553],{iconClass:"icon-Information_filled"});
                        isDuplicate = true;
                    }
                }
                if(elem && !elem.multiple && !isDuplicate) {
                    angular.element(elem).closest('form').find('.jx-fileListDiv').html("");
                }
                var filesList = $.extend(true, that.files, filesList),
                    invalidExtensions = [],
                    totalFiles = filesList.length,
                    fIndex = 0,
                    hasValid = 0;

                _.forEach(filesList,(file) =>{
                    let sFileName = file.name,
                        fileNameSplitedArr = sFileName.split('.'),
                        extension = fileNameSplitedArr[fileNameSplitedArr.length - 1].toLowerCase();
                    $rootScope.invoiceName = sFileName;
                    let showPageScope = $('ng-view').scope();
                    if(_.get(showPageScope,"showInvoiceUploadDialog.visible") && INVOICE_VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                        invalidExtensions.push(extension);
                    }else if (VALIDEXTENSIONS.indexOf(extension) < 0 && invalidExtensions.indexOf(extension) < 0) {
                        invalidExtensions.push(extension);
                    } else if (VALIDEXTENSIONS.indexOf(extension) != -1) {
                        hasValid++;
                    }
                    fIndex++;
                })

                var extensionMessage = intl_msg[24187]+" " + invalidExtensions.join(',') + ".";
                if ($rootScope.alertBoxes.length == 0 && that.files.length > 0) {
                    if (invalidExtensions.length > 0 && hasValid > 0) {
                        Toaster.create(UPLOADINPROGRESSMESSAGE + " " + extensionMessage,{iconClass:"icon-Information_filled"});
                    } else if (invalidExtensions.length > 0 && hasValid == 0) {
                        Toaster.create(extensionMessage,{iconClass:"icon-Information_filled"});
                        return;
                    } else {
                        Toaster.create(UPLOADINPROGRESSMESSAGE,{iconClass:"icon-Information_filled"});
                    }
                }
                if (isDuplicate) {
                    elem && angular.element(elem).val('');
                    return;
                }

                /** changed code for positioning of uploadedfiles in new ui 2.0 **/
                if (!angular.element(elem).closest('form').find('.jx-fileListDiv').length) {
                    let noMousePointerLabel  =angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').next('label.noMousePointer');
                    if (noMousePointerLabel.length > 0) {
                        noMousePointerLabel.after($('<div/>', {
                            'class': 'jx-fileListDiv'
                        }));
                    }else {
                        angular.element(elem).closest('.myPopUpFileUpload,.myFileUpload').after($('<div/>', {
                            'class': 'jx-fileListDiv'
                        }));
                    }
                }
                that.jqueryElem = $(elem).closest('form').find('.jx-fileListDiv');

                /** changed code for positioning of uploadedfiles in new ui 2.0 **/
                var totalFiles = that.files.length,
                    count = 0;

                _.forEach(that.files,(file,j) => {


                    let sFileName = that.files[indexFU].name,
                        arrayOfNamesSplitted = sFileName.split('.');

                    arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);

                    let sFileNameWithoutExt = arrayOfNamesSplitted.join("."),
                        fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase(),
                        removeLBL = intl_msg[28358];

                    if (hasValid == 0) {
                        stopLoader();
                    }
                    if (VALIDEXTENSIONS.indexOf(fileExtension) > -1) {
                        var action = 'onclick="angular.element(this).scope().clickThis($(this).parent().attr\(\'id\'),$(this).parent().prev())"';
                        var fileKey = formService.getFileKey(file.name); // May be we can remove it ( not sure )
                        var isClassificationShown = false;
                        var newelem = "<span class='file jx-fileListSpan' data-elemname='" + $(elem).attr('name') + "' id='" + fileKey + "' style='text-overflow: ellipsis;white-space:nowrap !important;' file=\"" + fileKey + "\"><small class='jx-uplodedFN' title='" + escapeHtml(file.name) + "'>" + escapeHtml(that.truncateFileName(file.name)) + "</small><span title='" + escapeHtml(removeLBL) + "' class='upload-delete icon-close' " +
                            "onclick=\"angular.element(this).scope().clickThis($(this).parent().attr('id'))\"></span><span class='icon-" + escapeHtml(that.truncateFileName(file.name)).split(/[. ]+/).pop().toLowerCase() + "' style='font-size: 20px; position: absolute; left: 0px; top:2px;'></span>";

                        _.forEach(extraFields, (d,i) => {

                            var value = false;
                            if (d.properties["default"] == true) {
                                value = true;
                            }
                            if (d.name && d.type == "checkbox") {
                                newelem = newelem + "<span class='searchableBox'></span>";
                            }
                            if ( [61, 160].indexOf(that.data.entityTypeId.values) > -1
                                && d.type == "basic" && d.properties
                                && d.properties.multiselect == "true" && d.fields && d.fields.length > 0
                            ) {
                                var optn = "";
                                isClassificationShown = true;
                                var filePropertiesTempplate = '<div  class="uploadFileProps" >' +
                                    '<i class="icon-Gear-Settings-line"  ng-class="{ \'active\' : isVisible($event,\'' + fileKey + '' + '\') }"  id="icon-Gear-Settings-line" title={{intl_msg[29024]}}  ' +
                                    'outside-if-not="propertiesSpan_'+fileKey+'" ' +
                                    'click-outside="closeProperties($event,\'' + fileKey + '' + '\')" ' +
                                    'data-ng-click  = "openProperties($event,\'' + fileKey + '' + '\')"  ></i>' +
                                    '<span  class="propertiesSpan" id="propertiesSpan_'+fileKey+'" ng-show="isVisible($event,\'' + fileKey + '' + '\')">'
                                    + SirionUtils.appendDocProperties(d,that.data,true,that.layout); + '</span></div>';
                                newelem = newelem + filePropertiesTempplate;
                            }

                        })
                        if(_.get(that.data,"comment.documentTags['options']['data']")
                            && _.get(that.data,"comment.documentTags['options']['data']").length
                            &&  SirionUtils.checkForDocTagPermission(that.layout)
                            &&  [12,13,61,160].indexOf(that.data.entityTypeId.values) > -1 ){
                            if(!isClassificationShown){
                                var filePropertiesTempplate = '<div  class="uploadFileProps" >' +
                                    '<i class="icon-Gear-Settings-line"  ng-class="{ \'active\' : isVisible($event,\'' + fileKey + '' + '\') }" id="icon-Gear-Settings-line" title="Settings"  ' +
                                    'outside-if-not="propertiesSpan_'+fileKey+'" ' +
                                    'click-outside="closeProperties($event,\'' + fileKey + '' + '\')" ' +
                                    'data-ng-click  = "openProperties($event,\'' + fileKey + '' + '\')"  ></i>' +
                                    '<span  class="propertiesSpan" id="propertiesSpan_'+fileKey+'" ng-show="isVisible($event,\'' + fileKey + '' +'\')"  >' +
                                    SirionUtils.appendDocTagsOnly(newelem,that.data.comment.documentTags); + '</span></div>';
                                newelem = newelem + filePropertiesTempplate;
                            }
                        }
                        newelem = newelem + "</span>";
                        var fd = new FormData();
                        var showPageControllerScope = $('ng-view').scope();
                        var showInvoiceDialogBool = _.get(showPageControllerScope,"showInvoiceUploadDialog.visible") || showPageControllerScope.radioButtonValue == 'invoice';
                        const modalScope = $('.modal').scope();
                        if(!showInvoiceDialogBool && modalScope)
                            showInvoiceDialogBool = modalScope.radioButtonValue === 'invoice';
                        let headers = {}
                        if (that.drsEnabled && drsObject) {
                            fd.append("multipartFile", file)
                            fd.append("envDetail", drsObject.sirionEnvDetails)
                            fd.append("clientId", window.clientId);
                            if(window.sessionStorage.getItem('drsPathBasedRouting')==='false')
                                headers['Authorization'] = sessionStorage.getItem("accessToken");
                        } else {
                            fd.append("documentFileData", file);
                            fd.append("key", fileKey);
                        }
                        fd.append("name", sFileNameWithoutExt.replace(/\./g, "_"));
                        fd.append("extension", fileExtension);
                        showInvoiceDialogBool ? fd.append("invoiceCopy", true) : null;
                        uploadFileApiCall(elem,fd,apiURL,headers).then(res => {
                            if(res) {
                                $("[name='documentFileData']").parent().find("button").removeClass("errorClass");
                                if ($(elem).hasClass("singleFile")) {
                                    that.SingleFileDelMsg = true;
                                    $(elem).closest(".adv-textbox").find(".singleFileUpload").hide();
                                } else {
                                    that.SingleFileDelMsg = false;
                                }

                                if(callback) {
                                    let key = that.drsEnabled ? _.get(res,'documentDetails.documentId') : fileKey;
                                    let keyList = [{key:key}]
                                    callback(keyList);
                                    return;
                                }

                                /*//Todo :  HARADCODED - check if 'Contract Managing Unit' is 'RIHQ' then RUSSIAN GENERAL should be by-default selected - NEED TO MAKE IT GENERIC
                                if(_.has($rootScope.data, "dynamicMetadata.dyn103684.values.id") && $rootScope.data.dynamicMetadata.dyn103684.values.id == 2073){
                                    $("span.file select").find("[value=12059]").prop("selected", true);
                                }*/


                                that.jqueryElem.append(newelem);

                                if( that.drsEnabled ) {
                                    $("#"+fileKey).attr("file",_.get(res,"documentDetails.documentId"));
                                }
                                //  Compile and update DOM
                                $compile(that.jqueryElem)(this);

                                $("span.file select").multiselect({
                                    selectedList: 4,
                                    position: {my: 'right top', at: 'right top'},
                                    open: function (event, ui) {
                                        // event handler here
                                        angular.element(event.target).closest('.jx-fileListSpan').addClass('activeSpan');
                                    },
                                    close: function (event, ui) {
                                        // event handler here
                                        angular.element(event.target).closest('.jx-fileListSpan').removeClass('activeSpan');
                                    }
                                });
                                $(elem).closest("span.label-height").find("span.sem").html("");
                                count++;
                                if (count == hasValid) {
                                    stopLoader();
                                    if ($rootScope.alertBoxes.length > 0) {
                                        modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
                                        modalToClose.close();
                                        $rootScope.alertBoxes.pop();
                                    }
                                }

                                that.enableAddComment = true;
                                $timeout(() =>{
                                    that.$apply();
                                })
                            }
                        })
                        indexFU++;
                    }

                })
                angular.element(elem).val('');
                resolve(true)
            })
        }

        function errorMsgHandling(modalToClose,errorMsg) {
            let showToast = false,
                toastMsg  = '';
            if (errorMsg== "virusvirusvirusvirus") {
                toastMsg = intl_msg[6551];
                showToast = true;
            } else if (errorMsg == "virusCheckFailed") {
                toastMsg = intl_msg[27946];
                showToast = true;
            } else if (errorMsg == "extensionError") {
                toastMsg = intl_msg[6500];
                showToast = true;
            }else if (errorMsg == "largeFile") {
                let _mgs =  parseInt(MAX_UPLOAD_SIZE / 1000000);
                toastMsg = intl_msg[6894].replace(/%s/g, _mgs) ;
                showToast = true;
            }
            if(modalToClose && showToast) {
                modalToClose.result.then(function () {
                    $rootScope.alertBoxes.pop();
                    Toaster.create(toastMsg,{iconClass:"icon-Information_filled"});
                });
                modalToClose.close();
            }else if(showToast) {
                Toaster.create(toastMsg,{iconClass:"icon-Information_filled"});
            }
            return showToast ? null : true;
        }

        function responseHandler(response) {
            let modalToClose = $rootScope.alertBoxes[$rootScope.alertBoxes.length - 1];
            if(response.status == 400) {
                let errorMsg = _.get(response,"data.message");
                return  errorMsgHandling(modalToClose,errorMsg);
            }else if( ![200,201].find(item=>item===response.status) ) {
                if(modalToClose) {
                    modalToClose.result.then(function () {
                        $rootScope.alertBoxes.pop();
                        Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                    });
                    modalToClose.close();
                }else {
                    Toaster.create(intl_msg[6552],{iconClass:"icon-Information_filled"});
                }
                return null;
            }else if (_.get(response,"data.header.response.status") == "applicationError") {
                let message = _.get(response,"data.header.response.errorMessage") || "Something went wrong";
                SirionUtils.openSirionDialogs({popupType: 'alert', str: "Something went wrong", heading: "NOTIFICATION"});
                return null;
            }else if (_.get(response,'errorMessages.length')) {
                let arr = response.errorMessages;
                if(arr.length == 1){
                    htmlError+=arr[0]["errorMessage"];
                }else{
                    for(var i = 0;i<arr.length;i++){
                        htmlError+="<p><span>"+(i+1)+". </span><span>"+arr[i]["errorMessage"]+"</span></p>";
                    }
                }
                SirionUtils.openSirionDialogs({popupType: 'alert', str: htmlError, heading: "NOTIFICATION"});
                return null;
            }else if(response.data){
                let returnValue = response.data;
                if(typeof returnValue == "string") {
                    const res = errorMsgHandling(modalToClose,returnValue);
                    !res && (returnValue = null);
                }
                return returnValue;
            }
        }
    }]);
})();
